<template>
  <div class="pa-4">
    <div
      v-t="'productDetails.numberOfUsers'"
      class="user-count-slider-title mb-7"
    />
    <v-slider
      v-model="maxUserCount"
      v-bind="sliderProps"
    />
    <div class="d-flex justify-space-between">
      <div
        v-for="value in sliderValues"
        :key="value"
      >
        {{ $tc('productDetails.upTo_count', value) }}
      </div>
    </div>
  </div>
</template>

<script>
const sliderValues = [25, 50, 100]
export default {
  props: {
    initialValue: {
      type: Number,
      default: 5
    },
    bundlesOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      maxUserCount: this.bundlesOnly
        ? this.initialValue
        : this.getSliderTick(),
      sliderValues
    }
  },
  computed: {
    sliderProps () {
      return this.bundlesOnly ? {
        thumbSize: '24',
        thumbLabel: 'always',
        min: 1
      } : {
        max: this.sliderValues.length - 1,
        step: 1,
        ticks: 'always',
        tickSize: 4
      }
    }
  },
  watch: {
    maxUserCount (val, oldVal) {
      if (val !== oldVal) {
        const count = this.bundlesOnly ? val : this.sliderValues[val]
        this.$emit('change', count)
      }
    }
  },
  methods: {
    getSliderTick () {
      const index = sliderValues.findIndex(val => this.initialValue === val)
      return index >= 0 ? index : 0
    }
  }
}
</script>

<style>
.user-count-slider-title {
  text-align: center;
  font-size: 16px;
}
</style>
